import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['form', 'submit'];

  connect() {
    this.initializeState();
    this.setupObservers();
  }

  disconnect() {
    this.observedElements.forEach(element => {
      element.removeEventListener("input", this.checkDirtiness.bind(this));
      element.removeEventListener("change", this.checkDirtiness.bind(this));
    });

    this.formTarget.removeEventListener("reset", this.resetForm.bind(this));
  }

  initializeState() {
    this.isDirty = false;
    this.observedElements = this.getObservedElements();
    this.initialValues = this.captureInitialValues();
  }

  getObservedElements() {
    return Array.from(
      this.formTarget.querySelectorAll("input, select, textarea")
    );
  }

  setupObservers() {
    this.formTarget.addEventListener("reset", this.resetForm.bind(this));

    this.observedElements.forEach(element => {
      element.addEventListener("input", this.checkDirtiness.bind(this));
      element.addEventListener("change", this.checkDirtiness.bind(this));
    });
  }

  resetForm() {
    this.isDirty = false;
    this.toggleSubmitButton(false);
  }

  captureInitialValues() {
    return Array.from(this.observedElements).reduce((acc, el) => {
      acc[el.name] = el.value;
      return acc;
    }, {});
  }

  getElementIdentifier(element) {
    return element.name || element.id;
  }

  checkDirtiness(element) {
    const identifier = this.getElementIdentifier(element.target);
    const initialValue = this.initialValues[identifier];
    const currentValue = element.target.value;
    const isDirty = currentValue !== initialValue;

    this.isDirty = isDirty;
    this.toggleSubmitButton(isDirty);
  }

  toggleSubmitButton(isDirty) {
    if (isDirty) {
      this.submitTarget.classList.add("dirty");
      this.submitTarget.disabled = false;
    } else {
      this.submitTarget.classList.remove("dirty");
      this.submitTarget.disabled = true;
    }
  }
}
